fx.ns("shared", class SplashContent {

	static get photos()
	{
		return ["personHappy", "personThinking", "personNice", "splashPhoto"];
	}

	static messages(mode)
	{
		if (mode == "creating" || mode == "creating-ia")
			return [
				{ title : "C'est parti !",             subtitle : "On va créer quelque chose de beau" },
				{ title : "Je prépare votre création", subtitle : "Ça va être génial !" },
				{ title : "Je m'occupe de tout",       subtitle : "Ce sera parfait !" },
				{ title : "Je mets tout en place",     subtitle : "Ça arrive tout de suite" }
			];

		return [
			{ title : "J'ouvre votre création",          subtitle : "Encore un petit instant..." },
			{ title : "On reprend votre création",       subtitle : "Ça arrive tout de suite" },
			{ title : "Je charge votre création",        subtitle : "C'est bientôt prêt" },
			{ title : "Vous êtes entre de bonnes mains", subtitle : "Vous allez pouvoir continuer" },
			{ title : "Bon retour !",                    subtitle : "Encore quelques secondes..." }
		];
	}

	static randomPhoto()
	{
		let photos = this.photos;

		let choices = [];
		for (let i = 0; i < photos.length; i++)
			if (photos[i] !== this._lastPhoto)
				choices.push(photos[i]);

		let photo = choices[Math.floor(Math.random() * choices.length)];
		this._lastPhoto = photo;
		return photo;
	}

	static randomMessage(mode)
	{
		let messages = this.messages(mode);

		let choices = [];
		for (let i = 0; i < messages.length; i++)
			if (i !== this._lastMessage)
				choices.push(i);

		if (!choices.length)
			for (let i = 0; i < messages.length; i++)
				choices.push(i);

		let index = choices[Math.floor(Math.random() * choices.length)];
		this._lastMessage = index;
		return messages[index];
	}

	static photo(key)
	{
		let assets = fx.get("assets");
		return assets[key] || assets.splashPhoto;
	}

});
